export function customSelect() {

    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            fakeDropInBody: false,
            maxVisibleItems: 8
        });
        jcf.replaceAll();
    }
    if (document.querySelector('.region-select-wrapper select')) {
        const regionSelect = document.querySelector('.region-select-wrapper select')
        const locationSelect = document.querySelector('.location-select-wrapper select')

        const locationSelectable = document.querySelector('.location-select-wrapper .selectable')
        const selectBtn = document.querySelector('.select-btn-redirect')
        let region, location;
        regionSelect.addEventListener('change', (e) => {
            region = e.target.value;
            const locationSelectOptions = document.querySelectorAll('.location-select-wrapper select option');
            locationSelectOptions.forEach(element => element.classList.contains(`${region}`) ? element.classList.remove('hidden') : element.classList.add('hidden'));
            locationSelect.removeAttribute('disabled')
            locationSelectable.classList.remove('disabled')
        })
        locationSelectable.addEventListener('change', (e) => {
            console.log('change select location', e.target.value);
            location = e.target.value;
            selectBtn.removeAttribute('disabled')
        })
        selectBtn.addEventListener('click', (e) => {
            window.location.href = location
            //check region and location + concatinate and redirect
        })
    }
}




// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js